import Scores from './Scores'
export default Scores